export default __webpack_public_path__ + "static/media/imgpost8.90185515.jpg";